(function (app) {
    app.provider("authTimeoutService", [function () {
        //TODO: clean up dependency circle here
        this.$get = ["$timeout", "$state", "$injector", function ($timeout, $state, $injector) {
            var timeoutPromise;

            function setTokenExpiration(expiration) { // expiration is Date
                // TODO: set/reset timer for alerting user session will end soon
                if (timeoutPromise)
                    $timeout.cancel(timeoutPromise);
                timeoutPromise = $timeout(onTimeout, expiration - new Date());
            }

            function onTimeout() {
                var AuthService = $injector.get("AuthService");
                // TODO: update this
                AuthService.logout().finally(function () {
                    $timeout(function () { $state.go("Login"); });
                });
            }

            return {
                setTokenExpiration: setTokenExpiration
            };
        }];
    }]);

    app.run(["crmApiGateway", function (crmApiGateway) {
        crmApiGateway.addInterceptor(["authTimeoutService", "AuthService", "$cookies", function (authTimeoutService, AuthService, $cookies) {
            var timerCookieKey = Symbol("timer");

            /*
             * this interceptor will take note of the timer cookie as the request goes out, and see if the timer has changed once we have the response
             * since the server will only send the Set-Cookie response with a new timer every few minutes, and javascript can't actually read the Set-Cookie response headers
             * we have to just check the cookie value before and after
             * if the timer has been reset from the server, we need to reset our internal timeout timer here too
             */
            return {
                request: function (config) {
                    config[timerCookieKey] = $cookies.get(".timer.advisorCrm");
                    return config;
                },
                response: function (response) {
                    var originalTimerCookie = response.config[timerCookieKey];
                    var timerCookie = $cookies.get(".timer.advisorCrm");
                    if (timerCookie && (originalTimerCookie !== timerCookie)) {
                        var expiration = new Date(timerCookie);
                        authTimeoutService.setTokenExpiration(expiration);
                    }

                    return response;
                }
            };
        }]);
    }]);

    app.run(["authTimeoutService", "AuthService", "$state", "$timeout", "$cookies", function (authTimeoutService, AuthService, $state, $timeout, $cookies) {
        var expiration = $cookies.get(".timer.advisorCrm");
        if (!expiration) return;
        var now = new Date();
        var expirationDate = new Date(expiration);
        if (now > expirationDate) {
            AuthService.logout().finally(function () {
                $timeout(function () { $state.go("Login"); });
            });
        } else {
            authTimeoutService.setTokenExpiration(expirationDate);
        }
    }]);

})(window.app); //jshint ignore:line